import { Box } from '@mui/material'
import { Outlet, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import TopBar from '../TopBar/TopBar'
import BottomNav from './BottomNav'
import { NAV_ITEMS } from './navItems'

const TOPBAR_HEIGHT = 64
const BOTTOM_NAV_HEIGHT = 56

/**
 * Mobile layout: fixed top bar, scrollable content, fixed bottom navigation.
 */
const GRADIENT = 'linear-gradient(90deg, #e9f7f1 0%, #eff5fa 50%, #d2dcf9 100%)'

const MobileLayout = () => {
    const { pathname } = useLocation()
    const { t } = useTranslation()
    const currentItem = NAV_ITEMS.find((item) => item.path === pathname)
    const pageTitle = currentItem?.headerTitle ?? (currentItem ? t(currentItem.labelKey) : 'HG-AT/DONATE-AT')

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', background: GRADIENT }}>
            <TopBar position="fixed" title={pageTitle} />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    overflow: 'auto',
                    mt: `${TOPBAR_HEIGHT}px`,
                    mb: `${BOTTOM_NAV_HEIGHT}px`,
                    px: 2,
                    py: 2,
                }}
            >
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        p: 2,
                        minHeight: '100%',
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
            <BottomNav />
        </Box>
    )
}

export default MobileLayout
